import { createSelector } from '@reduxjs/toolkit';
import { State as RootState } from '../store';
import { adapter, type } from './state';
import { CartItem } from '../../models/shop.model';

export const shopSelector = (state: RootState) => state[type];

const adapterSelectors = adapter.getSelectors(shopSelector);

export const productsSelector = createSelector(
    adapterSelectors.selectAll,
    (products) => products.filter(product => !!product)
);
export const productByIdSelector = adapterSelectors.selectById;
export const isFetchingSelector = createSelector(shopSelector, state => state.isFetching);
export const hasFetchedSelector = createSelector(shopSelector, state => state.hasFetched);
export const errorMessageSelector = createSelector(shopSelector, state => state.errorMessage);
export const cartSelector = createSelector(shopSelector, state => state.cart);
export const cartTotalSelector = createSelector(cartSelector, (cart: CartItem[]) => {
    return cart.reduce((total: number, item: CartItem) => total + (item.product.price * item.quantity), 0);
});
export const cartCountSelector = createSelector(cartSelector, (cart: CartItem[]) => {
    return cart.reduce((count: number, item: CartItem) => count + item.quantity, 0);
});
export const paymentUrlSelector = createSelector(shopSelector, state => state.paymentUrl);
export const proformaSelector = createSelector(shopSelector, state => state.proforma);
export const proformaStatusSelector = createSelector(shopSelector, state => state.proformaStatus);
